export default function (str) {
    const tmp = document.implementation.createHTMLDocument('')
    tmp.body.innerHTML = str
    return tmp.body.childNodes
}
